import { createContext, useContext } from 'react';

interface ArchivedProjectContextType {
  archived: true;
  projectId: string;
}

const ArchivedProjectContext = createContext<ArchivedProjectContextType | null>(null);

export const ArchivedProjectProvider = ({
  children,
  projectId,
}: {
  children: React.ReactNode;
  projectId: string;
}) => {
  return (
    <ArchivedProjectContext.Provider value={{ archived: true, projectId }}>
      {children}
    </ArchivedProjectContext.Provider>
  );
};

export const useIsArchivedProject = (): boolean => {
  const context = useContext(ArchivedProjectContext);
  return context !== null;
};

export const useArchivedProjectContext = (): ArchivedProjectContextType | null => {
  return useContext(ArchivedProjectContext);
};
